import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DBCompany } from 'src/app/core/models/companies.models';
import { CompaniesStoreService } from 'src/app/core/store/services/companies-store.service';

@Component({
  selector: 'craft-company-info-tooltip',
  template: `
    <ng-container *ngIf="company">
      <b>{{ company.name }}</b>
      <div class="info">
        Size: {{ company.size || 'N/A' }}, Value: {{ company.importance ? '$' + company.importance : 'N/A' }}
      </div>
    </ng-container>
  `,
  styleUrls: ['./craft-company-info-tooltip.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CraftCompanyInfoTooltipComponent {
  @Input() public company?: DBCompany | null;
}

@Component({
  selector: 'craft-company-info-button',
  template: `
    <ng-container *ngIf="companyStoreService.map$ | async as companies">
      <button
        class="btn-info"
        type="button"
        *ngIf="companyId && companies[companyId]"
        [craftHtmlTooltip]="companyInfoTooltip"
        [craftHtmlTooltipContext]="{ company: companies[companyId] }"
        [craftHtmlTooltipPosition]="'above'"
        [craftHtmlTooltipShowDelay]="300"
        [craftHtmlTooltipHideDelay]="200"
      >
        ({{ companies[companyId].name }})
      </button>
    </ng-container>

    <ng-template #companyInfoTooltip let-company="company">
      <craft-company-info-tooltip [company]="company"></craft-company-info-tooltip>
    </ng-template>
  `,
  styleUrls: ['./craft-company-info-button.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CraftCompanyInfoButtonComponent {
  @Input() public companyId?: string | null;
  constructor(public companyStoreService: CompaniesStoreService) {}
}

//
